import React, { useEffect, useState } from "react";

import { GetBucketArchiveListResponse } from "../../../common/api/delivery-api/GetBucketArchiveListResponse";
import { useBucketArchiveApi } from "../api/useBucketArchiveApi";
import { BucketArchiveItem } from "../listing/BucketArchiveItem";
import { BucketArchiveListingContext } from "./BucketArchiveListingContext";

interface BucketArchiveListingProviderProps {
    children: React.ReactNode;
}

export const BucketArchiveListingProvider: React.FC<BucketArchiveListingProviderProps> = (
    props: BucketArchiveListingProviderProps
) => {
    const { children } = props;

    const { getArchiveBucketList } = useBucketArchiveApi();

    const [bucketArchiveItems, setBucketArchiveItems] = useState<BucketArchiveItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        getArchiveBucketList().then((response: GetBucketArchiveListResponse) => {
            const buckets = response.items;
            setBucketArchiveItems(buckets);
            setIsLoading(false);
        });
        setIsLoading(false);
    }, []);

    const addBucketArchiveItem = (item: BucketArchiveItem) => {
        setBucketArchiveItems((prevState) => [...prevState, item]);
    };

    return (
        <BucketArchiveListingContext.Provider
            value={{
                bucketArchiveItems,
                isLoading,
                addBucketArchiveItem
            }}
        >
            {children}
        </BucketArchiveListingContext.Provider>
    );
};
